"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrencySymbol = void 0;
const data_1 = require("../utils/data");
const getCurrencySymbol = (currency) => data_1.CURRENCIES[currency].symbol;
exports.getCurrencySymbol = getCurrencySymbol;
